var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.advertisements && _vm.advertisements.length > 0
      ? _c(
          "div",
          { staticStyle: { "overflow-y": "scroll", height: "500px" } },
          [
            _c("div", { staticClass: "custom-table-responsive" }, [
              _c("table", { staticClass: "table table-striped" }, [
                _c("thead", [
                  _c("tr", [
                    _c(
                      "th",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.changeOrder("title")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("riportalApp.advertisement.title")
                              ),
                            },
                          },
                          [_vm._v("Title")]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.changeOrder("type.id")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("riportalApp.advertisement.type")
                              ),
                            },
                          },
                          [_vm._v("Type")]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.changeOrder("subsubcategory.name")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "riportalApp.advertisement.categorization"
                                )
                              ),
                            },
                          },
                          [_vm._v("Subsubcategory")]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.changeOrder("budget")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("riportalApp.advertisement.budget")
                              ),
                            },
                          },
                          [_vm._v("Budget")]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.changeOrder("company.id")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("riportalApp.advertisement.company")
                              ),
                            },
                          },
                          [_vm._v("Company")]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("th", [
                      _c(
                        "span",
                        {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("riportalApp.advertisement.companyRating")
                            ),
                          },
                        },
                        [_vm._v("Rating")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.changeOrder("activationDatetime")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "riportalApp.advertisement.activationDatetime"
                                )
                              ),
                            },
                          },
                          [_vm._v("Activation Datetime")]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.changeOrder("expirationDatetime")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "riportalApp.advertisement.expirationDatetime"
                                )
                              ),
                            },
                          },
                          [_vm._v("Expiration Date")]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("th"),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.advertisements, function (advertisement) {
                    return _c("tr", { key: advertisement.id }, [
                      _c(
                        "td",
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "text-body",
                              attrs: {
                                to: {
                                  name: "AdvertisementView",
                                  params: { advertisementId: advertisement.id },
                                },
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.emitHideAllEvent($event)
                                },
                              },
                            },
                            [_c("span", [_vm._v(_vm._s(advertisement.title))])]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        advertisement.type
                          ? _c("div", [
                              _vm.$store.getters.currentLanguage === "sr"
                                ? _c("span", [
                                    _vm._v(_vm._s(advertisement.type.type)),
                                  ])
                                : _vm.$store.getters.currentLanguage === "src"
                                ? _c("span", [
                                    _vm._v(_vm._s(advertisement.type.typeSrc)),
                                  ])
                                : _vm.$store.getters.currentLanguage === "en"
                                ? _c("span", [
                                    _vm._v(_vm._s(advertisement.type.typeEn)),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        advertisement.subsubcategory
                          ? _c("div", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.advertisementCategorizationBranch(
                                      advertisement
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        advertisement.budget
                          ? _c("div", [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    advertisement.budget.toLocaleString(
                                      "sr-SR",
                                      { style: "currency", currency: "RSD" }
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        advertisement.company
                          ? _c(
                              "div",
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "text-body",
                                    attrs: {
                                      to: {
                                        name: "CompanyView",
                                        params: {
                                          companyId: advertisement.company.id,
                                        },
                                      },
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.emitHideAllEvent($event)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(advertisement.company.name))]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        advertisement.company
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-direction": "row",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "mr-3" },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "star" },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getAverageRatingForCompany(
                                            advertisement.company.id
                                          )
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "handshake" },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getTotalRatingsForCompany(
                                            advertisement.company.id
                                          )
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            advertisement.activationDatetime
                              ? _vm.$d(
                                  Date.parse(
                                    advertisement.activationDatetime.toString()
                                  ),
                                  { dateStyle: "short" }
                                )
                              : ""
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            advertisement.expirationDatetime
                              ? _vm.$d(
                                  Date.parse(
                                    advertisement.expirationDatetime.toString()
                                  ),
                                  { dateStyle: "short" }
                                )
                              : ""
                          )
                        ),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.advertisements && _vm.advertisements.length === 0
      ? _c("div", [
          _c("div", { staticClass: "ml-2 mt-2" }, [
            _c("p", [
              _c(
                "span",
                {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("riportalApp.advertisement.searchNothingFound")
                    ),
                  },
                },
                [_vm._v("Nisu pronadjeni oglasi")]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }